import React, { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Icon } from "@iconify/react";
import '../../css/paywall.css';
import Button from "../../components/button/button";
import { useMakePayment } from '../../hooks/useMakePayment';
import SidebarContext from '../../contexts/MyContext';


const RedirectPage = () => {
  const location = useLocation();
  const navigate = useNavigate()
  const { handleMakePaymentOfPremium } = useMakePayment();
  const { premiumLoading, setUser } = useContext(SidebarContext)

  const queryParams = new URLSearchParams(location.search);
  const status = queryParams.get('status');


  useEffect(() => {
    const updateSubscriptionStatus = async () => {
      try {
        // Update isSubscriptionActive in localStorage
        const storedUser = JSON.parse(localStorage.getItem("currentUser"));
        if (storedUser) {
          const updatedUser = { ...storedUser, isSubscriptionActive: true, hasSubscribe: true};
          localStorage.setItem("currentUser", JSON.stringify(updatedUser));
          setUser(updatedUser);
        }
      } catch (error) {
        console.error("Failed to update subscription status:", error);
      }
    };

    updateSubscriptionStatus();
  }, []);





  const updateSubscriptionFlags = () => {
    navigate('/')
  }
  return (
    <div style={{ textAlign: 'center', padding: '20px' }}>
      {status === 'success' ? (
        <div className="premium_status">
          <div style={{ padding: '100px 300px', background: '#ffffff', borderRadius: '10px' }}>

            <img src="/img/success.png" width="87px" height="122px" style={{ objectFit: "contain" }} />
            <h1
              style={{
                fontFamily: 'Metropolis',
                fontWeight: '700',
                color: '#34D399',
                fontSize: '24px'
              }}
            >
              Payment Successful!
            </h1>
            <p
              style={{
                fontFamily: 'Metropolis',
                fontSize: '14px',
                fontWeight: '500',
                color: '#334155',
                width: '500px'
              }}
            >You have successfully purchased monthly subscription for VoiceRecorder.
              Please click on Continue button down below to proceed further.</p>
            <Button btnText={"Continue"} primary onClick={() => updateSubscriptionFlags()} />
          </div>
        </div>
      ) : status === 'cancel' ? (
        <div className="premium_status">
          <div style={{ padding: '100px 300px', background: '#ffffff', borderRadius: '10px' }}>
            <img src="/img/cancel.png" width="87px" height="122px" style={{ paddingBottom: '10px', objectFit: "contain" }} />
            <h1
              style={{
                fontFamily: 'Metropolis',
                fontWeight: '700',
                color: '#EF4444',
                fontSize: '24px'
              }}
            >
              Payment Failed!
            </h1>
            <p
              style={{
                fontFamily: 'Metropolis',
                fontSize: '14px',
                fontWeight: '500',
                color: '#334155',
                alignItems: 'center',
                width: '500px'
              }}
            >We're sorry, but your payment for monthly subscription was unsuccessful.
              Please check your payment details and try again.</p>
            <Button btnText={premiumLoading ? (

              <div
                className="spinner-border"
                role="status"
                style={{ width: "1.5rem", height: "1.5rem" }}
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            ) :
              (
                <>
                  Try Again
                </>
              )}
              primary
              onClick={() => handleMakePaymentOfPremium()}
            />
          </div>
        </div>
      ) : status === 'pending' ? (
        <div style={{ color: 'orange' }}>
          <h1>
            <span>
              <svg xmlns="http://www.w3.org/2000/svg" width="1.4em" height="1.4em" style={{ marginRight: '10px' }} viewBox="0 0 48 48"><circle cx="24" cy="24" r="20" fill="none" stroke="orange" strokeWidth="4" /><path fill="orange" d="M22 24h4v-9h-4v9zm0 8h4v-4h-4v4z" /></svg>
            </span>
            Payment Pending
          </h1>
          <p>Your payment is being processed. Please wait a moment.</p>
        </div>
      ) : (
        <div style={{ color: 'gray' }}>
          <h1>
            <span>
              <svg xmlns="http://www.w3.org/2000/svg" width="1.4em" height="1.4em" style={{ marginRight: '10px' }} viewBox="-2 -3 24 24"><path fill="yellow" d="m12.8 1.613l6.701 11.161c.963 1.603.49 3.712-1.057 4.71a3.2 3.2 0 0 1-1.743.516H3.298C1.477 18 0 16.47 0 14.581c0-.639.173-1.264.498-1.807L7.2 1.613C8.162.01 10.196-.481 11.743.517c.428.276.79.651 1.057 1.096m-2.22.839a1.077 1.077 0 0 0-1.514.365L2.365 13.98a1.17 1.17 0 0 0-.166.602c0 .63.492 1.14 1.1 1.14H16.7c.206 0 .407-.06.581-.172a1.164 1.164 0 0 0 .353-1.57L10.933 2.817a1.1 1.1 0 0 0-.352-.365zM10 14a1 1 0 1 1 0-2a1 1 0 0 1 0 2m0-9a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0V6a1 1 0 0 1 1-1"></path></svg>
            </span>
            Unknown Status
          </h1>
          <p>We couldn’t determine the payment status. Please contact support if you need help.</p>
        </div>
      )}
    </div>

  );
};

export default RedirectPage;